export default {
  // language=HTML (for PhpStorm)
  template: `
    <ui-form-partial label="Service" class="is-service-partial">
      <ui-form-item
        label="Service Start Date"
        prop="service.startDate"
      >
        <ui-date-picker-input
          name="service_start_date"
          v-model="model.service.startDate"
          label="Service Start Date"
        />
      </ui-form-item>

      <ui-form-item
        label="Service Type"
        prop="service.type"
      >
        <ui-form-radio
          name="service_type"
          v-model="model.service.type"
          label="Construction Required"
        />
        <ui-form-radio
          name="service_type"
          v-model="model.service.type"
          label="Existing Service"
        />
      </ui-form-item>

      <ui-form-item
        label="Comments and/or Directions to New Construction (optional)"
        prop="service.comments"
      >
        <ui-form-input
          name="service_comments"
          v-model="model.service.comments"
          type="textarea"
          rows="2"
        />
      </ui-form-item>

      <ui-form-item
        label="Is there an Outdoor Light installed by REMC on the property?"
        prop="service.hasRemcOutdoorLight"
      >
        <ui-form-radio
          name="service_has_remc_light"
          v-model="model.service.hasRemcOutdoorLight"
          label="Yes"
        />
        <ui-form-radio
          name="service_has_remc_light"
          v-model="model.service.hasRemcOutdoorLight"
          label="No"
        />
      </ui-form-item>

      <ui-form-item
        label="Do you want the Outdoor Light connected?"
        prop="service.wantsOutdoorLight"
      >
        <ui-form-radio
          name="service_wants_outdoor_light"
          v-model="model.service.wantsOutdoorLight"
          label="Yes"
        />
        <ui-form-radio
          name="service_wants_outdoor_light"
          v-model="model.service.wantsOutdoorLight"
          label="No"
        />
        <div class="help-text">(There is a monthly usage fee for the light.)</div>
      </ui-form-item>

      <ui-form-item
        label="Has the business ever had service with REMC before?"
        prop="service.previousService.hadService"
      >
        <ui-form-radio
          name="service_had_remc_before"
          v-model="model.service.previousService.hadService"
          label="Yes"
        />
        <ui-form-radio
          name="service_had_remc_before"
          v-model="model.service.previousService.hadService"
          label="No"
        />
      </ui-form-item>

      <template v-if="model.service.previousService.hadService === 'Yes'">
        <ui-form-item
          label="Previous Service Address"
          prop="service.previousService.address"
        >
          <ui-form-input
            name="service_prev_address"
            v-model="model.service.previousService.address"
            type="textarea" rows="2"
          />
        </ui-form-item>
      </template>

      <ui-form-item
        label="What type of business is it?"
        prop="service.typeOfBusiness"
      >
        <ui-form-input
          name="service_business_type"
          v-model="model.service.typeOfBusiness"
        >
          <span slot="append" class="muted">(optional)</span>
        </ui-form-input>
      </ui-form-item>

      <ui-form-item
        label="GO GREEN! Please select your preferred billing method"
        prop="service.preferredBillingMethod"
      >
        <ui-form-radio
          name="service_preferred_billing_method"
          v-model="model.service.preferredBillingMethod"
          label="Paper"
        />
        <ui-form-radio
          name="service_preferred_billing_method"
          v-model="model.service.preferredBillingMethod"
          label="Email"
        />
        <ui-form-radio
          name="service_preferred_billing_method"
          v-model="model.service.preferredBillingMethod"
          label="Both"
        />
      </ui-form-item>
    </ui-form-partial>
  `,

  props: {
    model: Object,
  },
}
